(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["section"] && !Shopify.designMode) return;
  try {
    
if(!customElements.get('usin-hero-carousel')){
customElements.define('usin-hero-carousel',class extends HTMLElement{
connectedCallback(){
if(this.bound)return;this.bound=true;const track=this.querySelector('.usin-hero-track');
this.addEventListener('click',event=>{const button=event.target.closest('button');if(!button)return;const current=Math.round(track.scrollLeft/track.clientWidth);const target=button.dataset.slide!==undefined?Number(button.dataset.slide):(current+Number(button.dataset.step)+2)%2;track.scrollTo({left:target*track.clientWidth,behavior:matchMedia('(prefers-reduced-motion:reduce)').matches?'instant':'smooth'});});
track.addEventListener('scroll',()=>{const current=Math.round(track.scrollLeft/track.clientWidth);this.querySelectorAll('[data-slide]').forEach(button=>button.setAttribute('aria-pressed',String(Number(button.dataset.slide)===current)));},{passive:true});
track.addEventListener('keydown',event=>{if(event.target!==track)return;if(event.key==='ArrowRight'||event.key==='ArrowLeft'){event.preventDefault();this.querySelector('[data-step="'+(event.key==='ArrowRight'?'1':'-1')+'"]').click();}});
}
});
}

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["usin-home-compact"] && !Shopify.designMode) return;
  try {
    
if(!customElements.get('usin-compact-showcase'))customElements.define('usin-compact-showcase',class extends HTMLElement{connectedCallback(){const button=this.querySelector('.usin-home-compact-more');if(!button||this.dataset.ready)return;this.dataset.ready='true';this.classList.add('is-collapsible');button.hidden=false;const label=button.textContent;button.addEventListener('click',()=>{const expanded=this.classList.toggle('is-expanded');button.setAttribute('aria-expanded',String(expanded));button.textContent=expanded?'Mostrar menos produtos':label;if(!expanded)this.querySelector('h2').scrollIntoView({block:'start',behavior:'smooth'})})}});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["usin-instagram"] && !Shopify.designMode) return;
  try {
    
document.querySelectorAll('.usin-instagram').forEach(section=>{if(section.dataset.ready)return;section.dataset.ready='true';const rail=section.querySelector('.usin-instagram__rail');const buttons=section.querySelectorAll('button[data-direction]');const update=()=>{buttons.forEach(button=>{button.disabled=Number(button.dataset.direction)<0?rail.scrollLeft<2:rail.scrollLeft+rail.clientWidth>=rail.scrollWidth-2})};buttons.forEach(button=>button.addEventListener('click',()=>{rail.scrollBy({left:Number(button.dataset.direction)*rail.clientWidth*.85,behavior:matchMedia('(prefers-reduced-motion: reduce)').matches?'instant':'smooth'})}));rail.addEventListener('scroll',update,{passive:true});new ResizeObserver(update).observe(rail);update()});

  } catch(e) { console.error(e); }
})();
})();
